import { Patient } from "common/models/types";

export type NhisTagColor = "Blue" | "Green" | "Red";

export interface NhisTagDescriptor {
  label: string;
  color: NhisTagColor;
}

const isToday = (iso?: string, now: Date = new Date()): boolean => {
  if (!iso) return false;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return false;
  return (
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate()
  );
};

/**
 * 3.5 태그 표시 규칙:
 *  - PENDING / AUTH_REQUESTED / FETCHED → "처방내역 조회중" (Blue)
 *  - DELIVERED → "처방내역 수신" (Green), 단 nhisLastStatusAt 이 오늘일 때만
 *  - FAILED → "조회 실패" (Red)
 *  - EXPIRED / CANCELLED / null → null (표시 안 함)
 */
export function resolveNhisTag(
  status: Patient["nhisLastStatus"],
  statusAt: string | undefined,
  now: Date = new Date(),
): NhisTagDescriptor | null {
  if (!status) return null;
  if (status === "EXPIRED" || status === "CANCELLED") return null;
  if (status === "DELIVERED" && !isToday(statusAt, now)) return null;

  if (status === "DELIVERED") return { label: "처방내역 수신", color: "Green" };
  if (status === "FAILED") return { label: "조회 실패", color: "Red" };
  // PENDING / AUTH_REQUESTED / FETCHED
  return { label: "처방내역 조회중", color: "Blue" };
}
